import { render } from "./AboutScreenTitle.vue?vue&type=template&id=166f510e&scoped=true"
import script from "./AboutScreenTitle.vue?vue&type=script&lang=js"
export * from "./AboutScreenTitle.vue?vue&type=script&lang=js"

import "./AboutScreenTitle.vue?vue&type=style&index=0&id=166f510e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166f510e"]])

export default __exports__